export const getDefaultState = () => ({
  items: [],
  attachments: [],
  prices: [],
  mediclubPrices: [],
  noMediclubPrices: [],
  id: null,
  appliedCoupons: [],
  appliedGiftCards: [],
  currentStep: 0,
  cartLoaded: false,

  now: Date.now(),
  reservationInterval: null,
  reservationTimeout: null,
  removedItems: [],
  paymentMethods: [],
  paymentMethodId: null,
  availablePaymentMethod: null,

  selectedPayment: null,
  isRegisteredOnCheckout: false,

  isCartReadOnly: false,
  setShippingMethodReadOnly: [],
  billingAddress: [],
})

export const state = () => ({
  ...getDefaultState(),
})
